function agentHas(keyword: string): boolean {
  return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

export function isSafari(): boolean {
  return (
    (!!window.ApplePaySetupFeature || !!window.safari) &&
    agentHas('Safari') &&
    !agentHas('Chrome') &&
    !agentHas('CriOS')
  );
}
